import { createContext, useContext, useMemo } from 'react'
import isBot from 'isbot'
import useLiff, { LiffEnv } from './useLiff'
import UserAgent from '@utils/userAgent'

export type Env = LiffEnv & {
  isWeb: boolean
  isAndroid: boolean
  isIOS: boolean
  isBot: boolean
}

const EnvContext = createContext<Env>({
  isIAB: false,
  isLiff: false,
  isLiffReady: false,
  baseUrl: '',
  isWeb: false,
  isAndroid: false,
  isIOS: false,
  isBot: false
})

export default EnvContext

const useEnv = () => useContext(EnvContext)

function useEnvProvider (userAgent: UserAgent): Env {
  const liffEnv = useLiff()
  const isBotResult = isBot(userAgent.getUaString())

  return useMemo(() => ({
    ...liffEnv,
    isWeb: !liffEnv.isLiff && !isBotResult,
    isAndroid: userAgent.isAndroid(),
    isIOS: userAgent.isIOS(),
    isBot: isBotResult
  }), [liffEnv, isBotResult, userAgent])
}

export { useEnvProvider, useEnv }
